import * as yup from 'yup';
import { errorMessages } from '~/constants/errorMessages.ts';

export const buildSupervisorContragentBlackListValidationSchema = () =>
  yup.object({
    email: yup
      .string()
      .trim()
      .required(errorMessages.FIELD_REQUIRED)
      .email(errorMessages.INVALID_EMAIL_FORMAT),
  });
